import React, { useEffect, useState } from 'react';
import {
  getOrgsToContact,
  getOrgsContacted,
  getOrgsPartial,
  OrganizationItem,
  OrganizationContactedItem,
  OrganizationProgressItem,   // ← importante
} from '../../api/adminOrganizationsService';
import Loader from '../Loader';
import FilterButton from '../../components/Admin/Investigations/FilterButton';
import ToContactPane from './Organizations/ToContactPane';
import InProgressPane from './Organizations/InProgressPane'; // ← nuevo
import ContactedList from './Organizations/ContactedList';
import { useTranslation } from 'react-i18next';

type Mode = 'to_contact' | 'partial' | 'contacted';
const PAGE_SIZE = 50;

const ContactOrganizationsView: React.FC = () => {
  const { t } = useTranslation();
  const [mode, setMode] = useState<Mode>('to_contact');

  const [page, setPage]   = useState(0);
  const [total, setTotal] = useState(0);
  const [items, setItems] = useState<
    (OrganizationItem | OrganizationContactedItem | OrganizationProgressItem)[]
  >([]);
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState<string>();

  const refetch = () => {
    setLoading(true);
    setError(undefined);

    const call =
      mode === 'to_contact'
        ? getOrgsToContact(page, PAGE_SIZE, true)  // ver TODOS los empleados
        : mode === 'partial'
        ? getOrgsPartial(page, PAGE_SIZE, true)    // ver TODOS y separarlos
        : getOrgsContacted(page, PAGE_SIZE);

    call
      .then((d) => {
        setItems(d.items);
        setTotal(d.total);
      })
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  };

  useEffect(refetch, [mode, page]);

  const totalPages = Math.max(1, Math.ceil(total / PAGE_SIZE));

  return (
    <div className="space-y-6">
      {/* Selector de modo */}
      <div className="flex gap-3">
        <FilterButton onClick={() => { setMode('to_contact'); setPage(0); }}
                      active={mode === 'to_contact'}>
          {t('admin.to_contact')}
        </FilterButton>

        <FilterButton onClick={() => { setMode('partial'); setPage(0); }}
                      active={mode === 'partial'}>
          {t('admin.in_progress')}
        </FilterButton>

        <FilterButton onClick={() => { setMode('contacted'); setPage(0); }}
                      active={mode === 'contacted'}>
          {t('admin.contacted')}
        </FilterButton>
      </div>

      {loading && <Loader />}
      {error   && <p className="text-red-500">{error}</p>}

      {!loading && !error && (
        <>
          {mode === 'to_contact' ? (
            <ToContactPane items={items as OrganizationItem[]} reload={refetch} />
          ) : mode === 'partial' ? (
            <InProgressPane items={items as OrganizationProgressItem[]} reload={refetch} />
          ) : (
            <ContactedList items={items as OrganizationContactedItem[]} />
          )}

          {/* paginación */}
          <div className="flex items-center justify-center gap-4">
            <FilterButton disabled={page === 0}
                          onClick={() => setPage(p => p - 1)}>
              « {t('admin.prev')}
            </FilterButton>
            <span>{page + 1} / {totalPages}</span>
            <FilterButton disabled={page + 1 >= totalPages}
                          onClick={() => setPage(p => p + 1)}>
              {t('admin.next')} »
            </FilterButton>
          </div>
        </>
      )}
    </div>
  );
};

export default ContactOrganizationsView;
